import { Box, Grid, Link, Typography } from "@mui/material";
import NorthEastIcon from "@mui/icons-material/NorthEast";
interface Title {
  title: string;
  value: string;
  sufix: string;
  sufixCls: string;
}

const StatusCard = (data: Title) => {
  return (
    <Grid item xl={3} sm={6}>
      <Link className="card group link-dark h-100" href="/chart/tx">
        <Box className="card-body">
          <Box className="d-flex justify-content-between align-items-center mb-1">
            <Typography className="text-cap mb-0">{data.title}</Typography>
            <NorthEastIcon className="text-icon text-secondary group-hover" />
          </Box>
          <Box>
            <span className="fs-5">{data.value}</span>
            <span className={`text-nowrap small ${data.sufixCls}`}>
              {data.sufix}
            </span>
          </Box>
        </Box>
      </Link>
    </Grid>
  );
};

export default StatusCard;
